import { request } from '@/shared/api/request'

export const rejectSelf = (externalId, person) => {
	return request({ url: `colcontract/tradeUnion/person/rejectSelf/${externalId}`, method: 'POST', data: person })
}
